import React from 'react'
import './navbar.css'

function Navbar() {
  return (
    <nav   className='navbar' >
        <a href='#skills' className='link-nav'  >SKILLS</a>
        <a href='#projects'  className='link-nav' >PROJECTS</a>
        <a href='#contact'  className='link-nav'  >CONTACT</a>
    </nav>
  )
}

export default Navbar